var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutdoorArea(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.3,
    stroke: "currentColor",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.75 10.375a4.367 4.367 0 00-2.542-3.958A2.462 2.462 0 0013.75 3.5c-.053 0-.102.013-.154.016a4.364 4.364 0 00-7.192 0c-.052-.003-.101-.016-.154-.016a2.462 2.462 0 00-2.458 2.917 4.366 4.366 0 00.921 8.237A3.402 3.402 0 0010 15.818a3.402 3.402 0 005.287-1.166 4.373 4.373 0 003.463-4.277zM10 7.875v12.5M10 13.5c2.5 0 3.75-1.25 3.75-3.75M10 11a2.953 2.953 0 01-3.125-3.125"
  }))));
}
export default SvgOutdoorArea;